import React from 'react';
import { Facebook, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-2">{companyInfo.name}</h3>
            <p className="text-sm text-slate-400 mb-4">{companyInfo.tagline}</p>
            <p className="text-slate-300 text-sm leading-relaxed mb-4">
              Especialistas em serviços de bate chapas, pintura automotiva e náutica em Loulé.
            </p>
            {/* Social Media */}
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/p/LMP-Pinturas-61555833007209/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              {[
                { label: 'Início', id: 'home' },
                { label: 'Serviços', id: 'services' },
                { label: 'Galeria', id: 'gallery' },
                { label: 'Orçamento', id: 'quote' },
                { label: 'Contato', id: 'contact' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Serviços</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Bate Chapas</li>
              <li>Pintura Automotiva</li>
              <li>Pintura Náutica</li>
              <li>Polimento</li>
              <li>Higienização</li>
              <li>Reparação de Lataria</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="text-blue-400 flex-shrink-0 mt-1" size={18} />
                <p className="text-sm text-slate-400">
                  {companyInfo.address}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-blue-400 flex-shrink-0" size={18} />
                <a 
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  {companyInfo.phoneFormatted}
                </a>
              </div>
            </div>

            {/* Working Hours Summary */}
            <div className="mt-4 p-3 bg-slate-800 rounded-lg">
              <p className="text-xs font-semibold text-slate-300 mb-1">Horário</p>
              <p className="text-xs text-slate-400">Seg-Qui: 07:00 - 18:00</p>
              <p className="text-xs text-slate-400">Sex: 07:00 - 13:00</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © {currentYear} {companyInfo.name}. Todos os direitos reservados.
            </p>
            <div className="flex gap-6 text-sm text-slate-400">
              <button className="hover:text-blue-400 transition-colors">
                Política de Privacidade
              </button>
              <button className="hover:text-blue-400 transition-colors">
                Termos de Serviço
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
